export { default } from './privacy-policy';
